import { useEffect } from 'react';
import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';
import useCrmObject from 'framework-asset-preview-lib/internal/shared/hooks/useCrmObject';
const EVENT_KEY = 'PREVIEW_LIB';
const REVEAL_SANDBOX_URL = 'REVEAL_SANDBOX_URL';

/**
 * Outputs the Sandbox URL for the crmObject used in preview-lib.
 * Useful for debugging preview components in external apps, especially in situations where it's necessary to isolate and test the preview component within the Sandbox App.
 *
 * Sample usage: window.postMessage({ key: 'PREVIEW_LIB', action: 'REVEAL_SANDBOX_URL' })
 */
export default function useRevealSandboxUrl() {
  const crmObject = useCrmObject();
  useEffect(() => {
    const handler = event => {
      if (!event || !event.data || !crmObject) {
        return;
      }
      const {
        key,
        action
      } = event.data;
      if (key !== EVENT_KEY) {
        return;
      }
      switch (action) {
        default:
          break;
        case REVEAL_SANDBOX_URL:
          {
            const sandboxUrl = `https://app.hubspot${enviro.isProd() ? '' : 'qa'}.com/framework-asset-preview-sandbox-ui/${PortalIdParser.get()}/${crmObject.objectTypeId}/${crmObject.objectId}`;
            console.group(`framework-asset-preview-lib (${crmObject.objectTypeId} - ${crmObject.objectId})`);
            console.log(`Sandbox URL = ${sandboxUrl}`);
            console.groupEnd();
            break;
          }
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [crmObject]);
}